export const STORE_URL = {
    ios: 'https://apps.apple.com/app/landlord-go-business-game/id1207764294',
    android: 'https://play.google.com/store/apps/details?id=co.reality.getrent',
}